import { lazy } from 'react';

import { Location } from '@cobliteam/common-types';

const ControlTowerPage = lazy(
  () => import('@cobliteam/routing/src/pages/ControlTower/ControlTower')
);
const RouteEditPage = lazy(
  () => import('@cobliteam/routing/src/components/RouteEditPage')
);
const ActivityEditPage = lazy(
  () => import('@cobliteam/routing/src/pages/ActivityEditPage')
);
const RoutingPage = lazy(
  () => import('@cobliteam/routing/src/pages/RoutingDashboardPage')
);

const routes = [
  {
    path: Location.SERVICES_AND_DELIVERIES_CONTROL_TOWER,
    component: ControlTowerPage,
    accessDeniedDescription: 'ver rotas',
  },
  {
    path: Location.ROUTE_EDIT,
    component: RouteEditPage,
    accessDeniedDescription: 'editar rotas em andamento',
  },
  {
    path: Location.ACTIVITY_EDIT,
    component: ActivityEditPage,
    accessDeniedDescription: 'editar rotas em andamento',
  },
  {
    path: Location.SERVICES_AND_DELIVERIES_PLANNING,
    component: RoutingPage,
    accessDeniedDescription: 'criar novas rotas',
  },
];

export default routes;
